// extracted by mini-css-extract-plugin
export var card = "_ow-0";
export var content = "_ow-2";
export var details = "_ow-3";
export var icon = "_ow-1";
export var iconBlue = "_ow-5";
export var iconBrand = "_ow-4";
export var iconGrayBlue = "_ow-6";
export var iconGreen = "_ow-7";
export var iconIndigo = "_ow-8";
export var iconOrange = "_ow-9";
export var iconPurple = "_ow-a";
export var iconRed = "_ow-b";
export var iconWarning = "_ow-c";